<template>
  <div class="transfer-box">
    <div class="left-table">
      <!-- 穿梭框左边 -->
      <div style="display: flex;align-items: center;justify-content: space-between">
        <div class="title">
          <span>用户列表</span>
<!--          <span class="num">3/8 条</span>-->
        </div>
        <el-form   class="demo-form-inline" :inline="true">
          <el-form-item label="用户名称" >
            <el-input v-model="username" placeholder="用户名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getIIamUseroAllFun">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        ref="multipleTable"
        :data="userList"
        style="width: 100%"
        @select="checkLeft"
        @select-all="checkAll"
        class="el-table-dialog"
        row-key="id"
        max-height="540"
        stripe
        :border="false"
        :header-row-style="{
          background: 'none',
          color: '#647196'
        }"
        :header-cell-style="{
          background: '#F1F4F6',
          color: '#3D4042',
          height: '56px',
          fontSize: '16px',
          padding: '0'
        }"
        :row-style="{
          background: 'none',
          height: '56px',
          borderBottom: '1px solid #D9DCDE'
        }"
        :cell-style="{
          background: 'none',
          color: '#3D4042',
          fontSize: '16px',
          borderBottom: '1px solid #D9DCDE'
        }"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>

        <el-table-column label="用户姓名" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属单位" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.deptName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位类型" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.deptName }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="center-box">
      <div style="text-align: center;">
        <el-button
          @click="right"
          type="primary"
          :disabled="nowSelectData.length ? false : true"
          icon="el-icon-arrow-right"
        ></el-button>
        <el-button
          @click="left"
          type="primary"
          :disabled="nowSelectRightData.length ? false : true"
          icon="el-icon-arrow-left"
          style="margin-left: 0;margin-top: 10px;"
        ></el-button>
      </div>
    </div>
    <div class="right-table">
      <!-- 穿梭框右边 -->
      <div class="title">
        <span>人员列表</span>
<!--        <span class="num">3/8 条</span>-->
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData2"
        style="width: 100%"
        @select="checkRight"
        @select-all="checkRightAll"
        row-key="id"
        class="el-table-dialog"
        max-height="540"
        stripe
        :border="false"
        :header-row-style="{
          background: 'none',
          color: '#647196'
        }"
        :header-cell-style="{
          background: '#F1F4F6',
          color: '#3D4042',
          height: '56px',
          fontSize: '16px',
          padding: '0'
        }"
        :row-style="{
          background: 'none',
          height: '56px',
          borderBottom: '1px solid #D9DCDE'
        }"
        :cell-style="{
          background: 'none',
          color: '#3D4042',
          fontSize: '16px',
          borderBottom: '1px solid #D9DCDE'
        }"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>

        <el-table-column label="人员姓名" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="人员所属部门（责任主体）" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.deptName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="责任人类型" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.nickName }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  getIIamUseroAll,
} from "@/api/point.js";
export default {
  props: {
    userList2: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      username: '',
      userList: [],
      tableData2: [],
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [] // 右边选中列表数据
    };
  },
  mounted() {
    this.getIIamUseroAllFun()
    // this.userList = JSON.parse(JSON.stringify(this.userList2));
  },
  methods: {
    async getIIamUseroAllFun() {
      const res = await getIIamUseroAll({username:this.username});
      this.userList = res.data.data;
    },
    // 左边全选事件
    checkAll(row) {
      this.nowSelectData = row;
    },
    // 右边全选事件
    checkRightAll(row) {
      this.nowSelectRightData = row;
    },
    // 左边选中事件
    checkLeft(row) {
      this.nowSelectData = row;
    },
    // 右边选中事件
    checkRight(row) {
      this.nowSelectRightData = row;
    },
    // 点击去右边
    right() {
      this.tableData2 = this.tableData2.concat(this.nowSelectData);
      this.handleRemoveTabList(this.nowSelectData, this.userList);
      // 按钮禁用
      this.nowSelectData = [];
      console.log(this.tableData2);
      this.$emit('selectedData',this.tableData2)
    },
    // 点击去左边
    left() {
      this.userList = this.userList.concat(this.nowSelectRightData);
      this.handleRemoveTabList(this.nowSelectRightData, this.tableData2);
      // 按钮禁用
      this.nowSelectRightData = [];
      console.log(this.tableData2);
      this.$emit('selectedData',this.tableData2)
    },
    // 方法
    handleRemoveTabList(isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            // 注意，nickName为唯一值，如果不为唯一值那么会出错
            if (isNeedArr[i]["id"] === originalArr[k]["id"]) {
              console.log("-----------1111");
              originalArr.splice(k, 1);
            }
          }
        }
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
.transfer-box {
  display: flex;
  .left-table,
  .right-table {
    padding: 16px 20px;
    width: 704px;
    height: 553px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    .title {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 16px;
      .num {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #92979c;
        margin-left: 24px;
      }
    }
  }
  .center-box {
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
/deep/.el-table-dialog {
  border: nono;
  thead {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/transfer-table/index.vue